(function () {
  function getCartAlpineData() {
    if (typeof Alpine === 'undefined' || typeof Alpine.$data !== 'function') return null;

    var onCartPage =
      window.location.pathname === '/cart' ||
      window.location.pathname.endsWith('/cart');

    if (onCartPage) {
      var cartForm = document.getElementById('cart');
      if (cartForm) {
        var formData = Alpine.$data(cartForm);
        if (formData && typeof formData.removeItem === 'function') return formData;
      }
    }

    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      var drawerData = Alpine.$data(drawer);
      if (drawerData && typeof drawerData.removeItem === 'function') return drawerData;
    }

    var fallback = document.querySelector('[x-data="xCart"]');
    if (fallback) {
      var fallbackData = Alpine.$data(fallback);
      if (fallbackData && typeof fallbackData.removeItem === 'function') return fallbackData;
    }

    return null;
  }

  document.addEventListener('alpine:init', function () {
    Alpine.store('xCartRemoveConfirm', {
      open: false,
      itemId: null,
      line: null,
      title: '',
      imageUrl: '',
      action: 'remove',
      // true when the dialog is the "clear whole cart" variant (no single item).
      clearAll: false,

      ask: function (itemId, line, title, imageUrl, action) {
        this.itemId = itemId;
        this.line = line;
        this.title = title || '';
        this.imageUrl = imageUrl || '';
        this.action = action === 'clear' ? 'clear' : 'remove';
        this.clearAll = false;
        this.open = true;
        document.body.classList.add('overflow-hidden');
      },

      // "Clear cart" toolbar button: empties the entire cart after confirmation.
      askClearAll: function () {
        this.itemId = null;
        this.line = null;
        this.title = '';
        this.imageUrl = '';
        this.action = 'clear';
        this.clearAll = true;
        this.open = true;
        document.body.classList.add('overflow-hidden');
      },

      cancel: function () {
        this.open = false;
        this.imageUrl = '';
        this.clearAll = false;
        document.body.classList.remove('overflow-hidden');
      },

      confirm: function () {
        var cart = getCartAlpineData();
        if (cart) {
          if (this.action === 'clear' && typeof cart.clearCart === 'function') {
            cart.clearCart(this.itemId);
          } else {
            cart.removeItem(this.itemId, this.line);
          }
        }
        this.cancel();
      },
    });
  });
})();
